import React from 'react'
import { Modal, Button } from 'antd'
import { DownloadOutlined } from '@ant-design/icons'

const RecoveryDashboardHelpModal = ({ visible, onClose }) => {
  const apiUrl = process.env.REACT_APP_API_URL || ''
  const downloadPdfUrl = `${apiUrl}${apiUrl && !apiUrl.endsWith('/') ? '/' : ''}download_summary_pdf?module=recovery-dashboard`

  return (
    <Modal
      title={
        <div className='recovery-dash-help-header'>
          <span className='recovery-dash-help-header-title'>Recovery Dashboard Summary</span>
        </div>
      }
      open={visible}
      visible={visible}
      onCancel={onClose}
      centered
      footer={[
        <a key='download' href={downloadPdfUrl} download='Recovery Dashboard Summary.pdf'>
          <Button type='primary' className='recovery-dash-help-download-btn' icon={<DownloadOutlined />}>
            Download PDF
          </Button>
        </a>
      ]}
      width={780}
      className='custom-modal recovery-dash-help-modal'
    >
      <div className='recovery-dash-help-content'>
        <div className='recovery-dash-help-card'>
          <div className='recovery-dash-help-title'>Recovery Dashboard</div>
          <p>
            The Recovery Dashboard provides a view of all inbound freight into the station which needs to be transported to the warehouse. The Dashboard gives the Warehouse Team information such as the product code, flight gate, location of the freight, the time since arrival of the flight. The applicable parameters from the system parameters module is the Breakdown Work area Mapping - Locations to work area mapping.
          </p>
        </div>

        <div className='recovery-dash-help-card'>
          <div className='recovery-dash-help-title'>Conditions to Add</div>
          <p>
            Freight is added on the dashboard once the flight arrival message is received by the Hub Control System. At this point the Arrival time is set and the Timer count begins from zero.
          </p>
        </div>

        <div className='recovery-dash-help-card'>
          <div className='recovery-dash-help-title'>Conditions to Remove</div>
          <ul className='recovery-dash-help-list'>
            <li>
              Freight is removed from the Dashboard once the AWB is moved to a location marked as a Breakdown Location from the System Parameters page - Breakdown Work area mapping.
            </li>
            <li>
              Certain shipments will receive an NFD or DLV message which will remove it from the dashboard.
            </li>
            <li>
              An AWB can also be manually removed from the Dashboard by using the &apos;Done&apos; checkbox.
            </li>
          </ul>
        </div>

        <div className='recovery-dash-help-card'>
          <div className='recovery-dash-help-title'>Order by</div>
          <p>
            The data displayed on the Recovery Dashboard is sorted based on the arrival time of the flight. The latest flight will be displayed at the bottom of the Dashboard and the earlier flights will be displayed at the top.
          </p>
        </div>

        <div className='recovery-dash-help-card'>
          <div className='recovery-dash-help-title'>Filters</div>
          <p>
            The data displayed on the Recovery Dashboard can be filtered by type - whether Transit, Local or ALL; Cargo - BLK, ULD; Product code; Location; Gate; or based on the Timer value. As the Hub Control System does not receives messages about certain product codes such as CM1, CM2 ; this data remains on the Recovery Dashboard unless manually removed.
          </p>
        </div>

        <div className='recovery-dash-help-card'>
          <div className='recovery-dash-help-title'>Comments</div>
          <p>
            The location column displays the current location of the AWB. If the location is displayed as the arrival flight number, it means that the Hub Control System has not received any FPS messages pertaining to this AWB and the AWB is still on the flight.
          </p>
          <p>
            If the location displayed is &apos;Checked in&apos; this means the &apos;to-location&apos; sent to the Hub Control System in the RCF is &apos;null&apos;.
          </p>
        </div>
      </div>
    </Modal>
  )
}

export default RecoveryDashboardHelpModal
